import { render, staticRenderFns } from "./edit_account_expire.vue?vue&type=template&id=d57fdbe4&scoped=true"
import script from "./edit_account_expire.vue?vue&type=script&lang=js"
export * from "./edit_account_expire.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/course-account-dialog.scss?vue&type=style&index=0&id=d57fdbe4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57fdbe4",
  null
  
)

export default component.exports